// * POST
export const POST_TICKET_TRANSFER = 'index/POST_TICKET_TRANSFER';
export const EXECUTE_TICKET_TRANSFER = 'index/EXECUTE_TICKET_TRANSFER';
export const CANCEL_TICKET_TRANSFER = 'index/CANCEL_TICKET_TRANSFER';
export const SET_COVERAGE_MAPPINGS = 'index/SET_COVERAGE_MAPPINGS';

// * Fetch
export const FETCH_EMPLOYEE_INSURANCE_COMPANIES_BY_RUT =
  'index/FETCH_EMPLOYEE_INSURANCE_COMPANIES_BY_RUT';
